// extracted by mini-css-extract-plugin
export default {"button":"TestsTable-module__button__PlNKc","selectForInterviewButton":"TestsTable-module__selectForInterviewButton__idHJy","actionsCell":"TestsTable-module__actionsCell__Bbh7o"};